import axios from 'axios';
import { getApiBaseUrl } from '../config/domains';

// API配置 - 使用动态域名
const API_BASE_URL = getApiBaseUrl();

// 创建axios实例
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

// 登录API
export const loginAPI = {
  // 商户/装修公司登录（带角色验证）
  login: async (username: string, password: string, isRemember: boolean, userType: 'merchant' | 'company') => {
    const params = new URLSearchParams();
    params.append('User[user_name]', username);
    params.append('User[password]', password);
    if (isRemember) {
      params.append('User[is_remember]', '1');
    }
    // 传递禁止登录的角色ID（商户登录禁止客户角色10005，装修公司登录禁止入驻商户角色10012）
    params.append('forbidden_role_id', userType === 'company' ? '10012' : '10005');

    // 调用新的登录接口
    const response = await apiClient.post('/index.php?s=/api/passport/loginWithType', params);
    return response.data;
  },

  // 退出登录
  logout: async () => {
    const response = await apiClient.post('/index.php?s=/store/passport/logout');
    return response.data;
  },

  // 获取当前后台登录的管理员信息
  getStoreUserInfo: async () => {
    const response = await apiClient.get('/index.php?s=/api/passport/getStoreUserInfo');
    return response.data;
  },

  // 上传图片
  uploadImage: async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post('/index.php?s=/api/common/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // 获取装修公司信息（GET 请求）
  getCompanyInfo: async () => {
    const response = await apiClient.get('/index.php?s=/store/shop/company_store_info');
    return response.data;
  },

  // 保存装修公司信息（POST 请求）
  saveCompanyInfo: async (formData: FormData) => {
    const response = await apiClient.post('/index.php?s=/store/shop/company_store_edit', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },
};

export default apiClient;